import { Input, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";

function EllipsisTooltipInput({
  value,
  onChange,
  onBlur
}: {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
}) {
  const inputRef = useRef<any>(null);
  const [visible, setVisible] = useState(false);

  const checkOverflow = () => {
    const el = inputRef.current?.input;
    if (!el) return;
    setVisible(el.scrollWidth > el.clientWidth);
  };

  useEffect(() => {
    requestAnimationFrame(checkOverflow);
  }, [value]);

  return (
    <Tooltip title={visible ? value : undefined} destroyOnHidden>
      <Input
        ref={inputRef}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onMouseEnter={checkOverflow}
        onFocus={checkOverflow}
      />
    </Tooltip>
  );
}

export default EllipsisTooltipInput;
